import { mainSplitApi } from "../../mainSplitApi";
import STATS_TAG_TYPES from "./stats.tags";
import { StatsEndpoints } from "../../endpoints/stats.endpoints";
import { StatsValuesQRTK } from "./values/stats.values";
import { IStatsResponse } from "./responses/stats.response";

export const StatsQueryServices = mainSplitApi.injectEndpoints({
  endpoints: ({ query }) => ({
    stats: query<IStatsResponse, StatsValuesQRTK>({
      query: values => ({
        url: StatsEndpoints.Stats,
        method: "GET",
        params: values.query
      }),
      transformResponse: (response: IStatsResponse) => response,
      providesTags: [STATS_TAG_TYPES.STATS_GET]
    })
  })
});

export const { useStatsQuery, useLazyStatsQuery } = StatsQueryServices;
